import MapSagas from './map';
import itinerarySagas from './itinerary';
import { all } from 'redux-saga/effects';

export default function* rootSaga() {
    yield all([
        ...MapSagas,
        ...itinerarySagas
    ]);
}